import { Subject } from 'rxjs';
import { AuthStore } from './authStore';
import { CartStore } from './cartStore';
import { OrderStore } from './orderStore';
import { AddressStore } from './addressStore';
import { CardStore } from './cardStore';
import { CatalogStore } from './catalogStore';
import { ChatStore } from './chatStore';
import { SettingStore } from './settingStore';

// Корневой стор newgen. Один инстанс на страницу.
export class RootStore {
  constructor() {
    this.subject = new Subject();
    this.authStore = new AuthStore(this);
    this.cartStore = new CartStore(this);
    this.orderStore = new OrderStore(this);
    this.addressStore = new AddressStore(this);
    this.cardStore = new CardStore(this);
    this.catalogStore = new CatalogStore(this);
    this.chatStore = new ChatStore(this);
    this.settingStore = new SettingStore(this);
  }

  async bootstrap() {
    await this.authStore.bootstrap();
    // Корзина обновляется внутри authStore.setMobileToken через rootStore.cartStore.setCart
  }
}

let _singleton = null;
export const getRootStore = () => {
  if (!_singleton) _singleton = new RootStore();
  return _singleton;
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/rootStore.js